import type { CompanyInvitation } from "@repo/app-types/entities/companyInvitation";
import { api } from "../redux.js";

const companyInvitationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteCompanyInvitation: builder.mutation<void, string>({
      query: (id) => ({
        method: "DELETE",
        url: `/company-invitations/${encodeURIComponent(id)}`,
      }),
    }),

    pendingInvitationsPaginated: builder.infiniteQuery<
      {
        invitations: CompanyInvitation[];
        nextCursor: string | null;
      },
      { search?: string },
      string | null,
      {
        data: { invitations: CompanyInvitation[] };
        next_cursor: string | null;
      }
    >({
      infiniteQueryOptions: {
        initialPageParam: null,
        getPreviousPageParam: () => null,
        getNextPageParam: (lastPage) => lastPage.nextCursor,
      },
      query: ({ queryArg, pageParam }) => ({
        method: "GET",
        url: "/company-invitations/pending-invitations/paginated",
        params: {
          cursor: pageParam ?? undefined,
          limit: 20,
          search: queryArg.search ?? undefined,
        },
      }),
      transformResponse: (response) => ({
        invitations: response.data.invitations,
        nextCursor: response.next_cursor,
      }),
    }),
  }),
});

export const {
  useDeleteCompanyInvitationMutation,
  usePendingInvitationsPaginatedInfiniteQuery,
} = companyInvitationApi;
